import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { recentWeeks } from "@/lib/format";

export function WeekSelect({ value, onChange, testid = "week-select" }) {
  const weeks = recentWeeks(10);
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="w-[220px] bg-white">
        <SelectValue placeholder="Select week" />
      </SelectTrigger>
      <SelectContent>
        {weeks.map((w, i) => (
          <SelectItem key={w.value} value={w.value} data-testid={`week-opt-${i}`}>
            {i === 0 ? "This week · " : i === 1 ? "Last week · " : ""}{w.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
